module.exports = __webpack_public_path__ + "static/media/credit-card.6ac2e7d4.jpg";